import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${RouteGroup.CUSTOM_TRANSLATIONS}`,
      name: `${RouteGroup.CUSTOM_TRANSLATIONS}`,
      component: () =>
        import(
          /* webpackChunkName: "custom-translations-page" */ './pages/CustomTranslationsPage.vue'
        ),
    },
    {
      path: `/${RouteGroup.CUSTOM_TRANSLATIONS}/new`,
      name: `${RouteGroup.CUSTOM_TRANSLATIONS}form:new`,
      component: () =>
        import(
          /* webpackChunkName: "custom-translation-form-page" */ './pages/CustomTranslationFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${RouteGroup.CUSTOM_TRANSLATIONS}/:id`,
      name: `${RouteGroup.CUSTOM_TRANSLATIONS}form`,
      component: () =>
        import(
          /* webpackChunkName: "custom-translation-form-page" */ './pages/CustomTranslationFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.CUSTOMTRANSLATION
);
